<div class="alert alert-{{ type }} text-center p-2">{{ message }}</div>